<!--
 * $Description: 考勤sheet模式分钟数选择
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月17日 14:50:58 +0800
 * @最后修改时间: 2022-04-07 15:58:15
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_TimePickerSheet.vue
 -->
<template>
  <div>
    <v-sheet
      v-if="showLabel"
      class="text--secondary"
      :class="isRequire ? 'mrc_text_require' : ''"
      >{{ label }}</v-sheet
    >

    <v-menu
      color="white"
      offset-y
      v-model="showMenu"
      nudge-top="-4"
      :close-on-content-click="false"
      :max-width="showDay ? 300 : 220"
    >
      <template v-slot:activator="{ on }">
        <v-sheet
          class="text-center pl-1 pr-1"
          :class="
            disable ? 'rounded text-caption' : 'rounded-t text-subtitle-2'
          "
          width="100%"
          color="grey lighten-3"
          :style="{
            borderBottom: showMenu
              ? '2px solid var(--main-color) !important'
              : '1px solid grey !important',
          }"
          v-on="disable ? null : on"
        >
          {{ format ? formatTime : time }}</v-sheet
        >
        <v-text-field
          dense
          v-show="false"
          readonly
          :height="height"
          :prepend-inner-icon="prependInnerIcon"
          :value="format ? formatTime : time"
          v-on="disable ? null : on"
          :hide-details="hideDetail"
          :error-messages="getErrorMsg()"
          single-line
          :rules="isRequire ? $GetRules('_Require_Rules', [null]) : []"
        ></v-text-field>
        <!-- 2020-10-16mel不顯示總分鐘數 -->
        <!-- :messages="'Total Minute:' + TimeMinute" -->
      </template>
      <v-sheet
        color="white"
        class="pa-1 d-flex flex-column flex-grow-1"
        height="300"
        :width="showDay ? 300 : 220"
      >
        <v-row
          justify="start"
          col="12"
          class="pa-1 pt-3 d-flex flex-nowrap justify-center text-center"
          style="height: 50px"
        >
          <v-col md="3" v-if="showDay" class="pa-0 text-center numberInput">
            <v-text-field
              label="Day"
              dense
              class="text-center"
              single-line
              :maxlength="2"
              @keyup="onChange('day')"
              @blur="onBlur('day')"
              placeholder="Day"
              v-model="day"
            ></v-text-field>
          </v-col>
          <v-col md="1" v-if="showDay" class="pa-0"></v-col>
          <v-col :md="showDay ? 3 : 4" class="pa-0 numberInput">
            <v-text-field
              dense
              label="HH"
              single-line
              :maxlength="2"
              @keyup="onChange('hour')"
              @blur="onBlur('hour')"
              class="text-center"
              placeholder="HH"
              v-model="hour"
            ></v-text-field>
          </v-col>
          <v-col :md="showDay ? 1 : 2" class="align-self-center pa-0">:</v-col>
          <v-col :md="showDay ? 3 : 4" class="pa-0 numberInput">
            <v-text-field
              dense
              single-line
              :maxlength="2"
              @keyup="onChange('min')"
              @blur="onBlur('min')"
              label="MM"
              class="text-center"
              placeholder="MM"
              v-model="minute"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row
          class="d-flex flex-nowrap justify-center pa-1"
          style="height: calc(100% - 50px)"
        >
          <v-col
            md="3"
            v-if="showDay"
            ref="day"
            class="pa-1 scroll_content_y"
            style="
              height: 100%;
              overflow-y: scroll;
              overflow-x: hidden;
              border-bottom: 1px solid var(--main-border-color);
            "
          >
            <!-- <v-btn
              outlined
              :color="-1 == day ? 'primary' : 'grey lighten-2'"
              class="text-center mt-1 text-block"
              @click="setDay('-1')"
              >{{ "-1" }}</v-btn
            >
            <v-btn
              outlined
              :color="0 == day ? 'primary' : 'grey lighten-2'"
              class="text-center mt-1 text-block"
              @click="setDay(0)"
              >{{ "0" }}</v-btn
            > -->
            <v-btn
              outlined
              v-for="(i, index) in allday"
              :color="allday[index] == day ? 'primary' : 'grey lighten-2'"
              class="text-center mt-1 text-block"
              @click="setDay(allday[index])"
              :key="index"
              >{{ (allday[index] <= 0 ? "" : "+") + allday[index] }}</v-btn
            >
          </v-col>
          <v-col md="1" class="pa-0" v-if="showDay"></v-col>
          <v-col
            :md="showDay ? 3 : 4"
            class="pa-1 scroll_content_y"
            ref="hours"
            style="
              height: 100%;
              overflow-y: scroll;
              overflow-x: hidden;
              border-bottom: 1px solid var(--main-border-color);
            "
          >
            <v-btn
              :text="hour == '00' ? false : true"
              class="text-center mt-1 pa-1 text-block"
              @click="setHour('00')"
              :disabled="isCanSelect('hour', '00')"
              depressed
              :key="'00'"
              :color="
                hour == '00'
                  ? 'primary lighten-4 text--primary'
                  : 'text--primary'
              "
              >00</v-btn
            >
            <v-btn
              v-for="i in show48"
              :text="hour == (i >= 10 ? i : '0' + i) ? false : true"
              class="text-center mt-1 pa-1 text-block"
              :key="i >= 10 ? i : '0' + i"
              depressed
              :disabled="isCanSelect('hour', i >= 10 ? i : '0' + i)"
              :color="
                hour == (i >= 10 ? i : '0' + i)
                  ? 'primary lighten-4 text--primary'
                  : 'text--primary'
              "
              @click="setHour(i >= 10 ? i : '0' + i)"
              >{{ i >= 10 ? i : "0" + i }}</v-btn
            >
          </v-col>
          <v-col :md="showDay ? 1 : 2" class="pa-0"></v-col>
          <v-col
            :md="showDay ? 3 : 4"
            class="pa-1 scroll_content_y"
            ref="minutes"
            style="
              height: 100%;
              overflow-y: scroll;
              overflow-x: hidden;
              border-bottom: 1px solid var(--main-border-color);
            "
          >
            <v-btn
              :text="minute == '00' ? false : true"
              class="text-center mt-1 pa-1 text-block"
              @click="setMinute('00')"
              :disabled="isCanSelect('min', '00')"
              depressed
              :key="'00'"
              :color="
                minute == '00'
                  ? 'primary lighten-4 text--primary'
                  : 'text--primary'
              "
              >00</v-btn
            >
            <v-btn
              v-for="i in 59"
              :text="minute == (i >= 10 ? i : '0' + i) ? false : true"
              class="text-center mt-1 pa-1 text-block"
              :key="i >= 10 ? i : '0' + i"
              :disabled="isCanSelect('min', i >= 10 ? i : '0' + i)"
              depressed
              :color="
                minute == (i >= 10 ? i : '0' + i)
                  ? 'primary lighten-4 text--primary'
                  : 'text--primary'
              "
              @click="setMinute(i >= 10 ? i : '0' + i)"
              >{{ i >= 10 ? i : "0" + i }}</v-btn
            >
          </v-col>
        </v-row>
      </v-sheet>
    </v-menu>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "MrcTimePickerSheet",
  props: {
    isEnd: { default: false, type: Boolean },
    show48: { default: 47, type: [String, Number] },
    showDay: { default: false, type: Boolean },
    format: { default: false, type: Boolean },
    label: { default: "", type: String },
    showLabel: { default: true, type: Boolean },
    min: { default: "", type: [String, Number] },
    height: { default: "", type: [String, Number] },
    max: { default: "", type: [String, Number] },
    disable: { default: false, type: Boolean },
    prependInnerIcon: { default: "", type: String },
    hideDetail: { default: false, type: Boolean },
    isRequire: { default: false, type: Boolean },
    value: { default: "", type: [String, Number] },
    defaultTime: { default: "", type: [String, Number] },
    placeholder: { default: "time", type: String },
  },
  computed: {
    ...mapGetters(["defaultLang"]),
    ErrorMsg() {
      return this.getErrorMsg();
    },
  },
  data() {
    return {
      allday: [-1, 0, 1],
      day: 0,
      showMenu: false,
      hour: "00",
      formatTime: "00:00",
      isError: false,
      minute: "00",
      time: "00:00",
      i: 0,
      TimeMinute: 0,
    };
  },
  mounted() {
    const that = this;
    if (this.defaultTime) {
      let val = this.defaultTime;
      this.time = this.$timeMachine(val);
      if (val < 0) {
        this.day = Math.ceil(Number(val) / (24 * 60));
        this.hour = Math.floor((Number(-val) + this.day * (24 * 60)) / 60);
        this.minute = Number(-val) + this.day * (24 * 60) - this.hour * 60;
        this.hour = this.hour >= 10 ? this.hour : "0" + this.hour;
        this.minute = this.minute >= 10 ? this.minute : "0" + this.minute;
        this.TimeMinute = -this.timeMachine(
          Math.abs(this.day),
          this.hour,
          this.minute
        );
      } else {
        this.day = Math.floor(Number(val) / (24 * 60));
        this.hour = Math.floor((Number(val) - this.day * (24 * 60)) / 60);
        this.minute = Number(val) - this.day * (24 * 60) - this.hour * 60;
        this.hour = this.hour >= 10 ? this.hour : "0" + this.hour;
        this.minute = this.minute >= 10 ? this.minute : "0" + this.minute;
        this.TimeMinute = this.timeMachine(this.day, this.hour, this.minute);
      }
    }
    this.formatTime = this.$timeMachine(this.TimeMinute || 0, true);
  },

  watch: {
    showMenu(val) {
      if (val) this.$emit("modify"); //触发修改操作
    },
    defaultTime(val) {
      if (val && this.i == 0) {
        this.i = 1;
        this.time = this.$timeMachine(val);
        if (val < 0) {
          this.day = Math.ceil(Number(val) / (24 * 60));
          this.hour = Math.floor((Number(-val) + this.day * (24 * 60)) / 60);
          this.minute = Number(-val) + this.day * (24 * 60) - this.hour * 60;
          this.hour = this.hour >= 10 ? this.hour : "0" + this.hour;
          this.minute = this.minute >= 10 ? this.minute : "0" + this.minute;
          this.TimeMinute = -this.timeMachine(
            Math.abs(this.day),
            this.hour,
            this.minute
          );
        } else {
          this.day = Math.floor(Number(val) / (24 * 60)); //改为最多输入48小时
          this.hour = Math.floor((Number(val) - this.day * (24 * 60)) / 60);
          this.minute = Number(val) - this.day * (24 * 60) - this.hour * 60;
          this.hour = this.hour >= 10 ? this.hour : "0" + this.hour;
          this.minute = this.minute >= 10 ? this.minute : "0" + this.minute;
          this.TimeMinute = this.timeMachine(this.day, this.hour, this.minute);
        }
      }
      if (val == "0") {
        this.time = this.$timeMachine(val);
        if (val < 0) {
          this.day = Math.ceil(Number(val) / (24 * 60));
          this.hour = Math.floor((Number(-val) + this.day * (24 * 60)) / 60);
          this.minute = Number(-val) + this.day * (24 * 60) - this.hour * 60;
          this.hour = this.hour >= 10 ? this.hour : "0" + this.hour;
          this.minute = this.minute >= 10 ? this.minute : "0" + this.minute;
          this.TimeMinute = -this.timeMachine(
            Math.abs(this.day),
            this.hour,
            this.minute
          );
        } else {
          this.day = Math.floor(Number(val) / (24 * 60)); //改为最多输入48小时
          this.hour = Math.floor((Number(val) - this.day * (24 * 60)) / 60);
          this.minute = Number(val) - this.day * (24 * 60) - this.hour * 60;
          this.hour = this.hour >= 10 ? this.hour : "0" + this.hour;
          this.minute = this.minute >= 10 ? this.minute : "0" + this.minute;
          this.TimeMinute = this.timeMachine(this.day, this.hour, this.minute);
        }
      }
    },
    time(val) {
      this.formatTime = this.$timeMachine(this.TimeMinute || 0, true);
      this.$emit("change", this.TimeMinute.toString());
    },
    defaultLang() {
      //语言变化，修改翻译 2021-07-07
      this.formatTime = this.$timeMachine(this.TimeMinute || 0, true);
      this.$emit("change", this.TimeMinute.toString());
    },
  },
  methods: {
    getErrorMsg: function () {
      // console.log(this.min);
      // console.log(this.max);
      if (!this.min || !this.max) return "";

      if (this.showDay && this.TimeMinute < this.min) {
        this.isError = true;
        return "End time less than start time!";
      }
      if (this.showDay && this.TimeMinute >= this.min) {
        return "";
      }
      if (!this.showDay && this.TimeMinute > this.max) {
        this.isError = true;
        return "Start time is greater than end time!";
      }
      if (!this.showDay && this.TimeMinute <= this.max) {
        return "";
      }
    },
    isCanSelect: function (type, num) {
      num = Number(num);
      if (this.min <= 0) return false;
      if (!this.min && !this.max) {
        return false;
      } else {
        if (this.isEnd) {
          if (!this.min) return false;
          if (this.day > 0) return false;
          let min_hour = Math.floor(
            (Number(this.min) - this.day * (24 * 60)) / 60
          );
          let min_minute =
            Number(this.min) - this.day * (24 * 60) - min_hour * 60;
          if (type == "hour") {
            if (this.minute < min_minute) {
              if (num >= min_hour) {
                return false;
              } else {
                return true;
              }
            }
            if (this.minute >= min_minute) {
              if (num >= min_hour) {
                return false;
              } else {
                return true;
              }
            }
          }
          if (type == "min") {
            if (Number(this.hour) == min_hour) {
              if (num >= min_minute) {
                return false;
              } else {
                return true;
              }
            } else if (Number(this.hour) > min_hour) {
              return false;
            } else {
              return true;
            }
            // if (num >= min_minute) {
            //   return false;
            // } else {
            //   return true;
            // }
          }
        } else {
          if (!this.max) return false;
          let day = Math.floor(Number(this.max) / (24 * 60));
          if (day > 0) return false;
          let max_hour = Math.floor(
            (Number(this.max) - this.day * (24 * 60)) / 60
          );
          let max_minute =
            Number(this.max) - this.day * (24 * 60) - max_hour * 60;
          if (type == "hour") {
            if (this.minute > max_minute) {
              if (num < max_hour) {
                return false;
              } else {
                return true;
              }
            }
            if (this.minute <= max_minute) {
              if (num <= max_hour) {
                return false;
              } else {
                return true;
              }
            }
          }
          if (type == "min") {
            if (Number(this.hour) < max_hour) {
              return false;
            } else if (Number(this.hour) == max_hour) {
              if (num <= max_minute) {
                return false;
              } else {
                return true;
              }
            } else {
              return true;
            }
          }
        }
      }
    },
    timeMachine: function (day, hour, minute) {
      return Number(day) * 60 * 24 + Number(hour) * 60 + Number(minute);
    },
    onBlur: function (type) {
      switch (type) {
        case "day":
          if (this.day == "-") {
            this.setDay("00");
            break;
          }
          if (this.day) {
            this.setDay(this.day, true);
          } else {
            this.setDay("00");
          }

          break;
        case "hour":
          if (this.hour == "") {
            this.hour == "00";
          }
          if (Number(this.hour) >= 10) {
            this.setHour(this.hour);
          } else {
            this.setHour("0" + Number(this.hour));
          }
          break;
        case "min":
          if (this.minute == "") {
            this.minute == "00";
          }
          if (Number(this.minute) >= 10) {
            this.setMinute(this.minute);
          } else {
            this.setMinute("0" + Number(this.minute));
          }
          break;
        default:
          break;
      }
    },
    onChange: function (type) {
      switch (type) {
        case "day":
          if (this.day) {
            if (this.day == "-") {
              break;
            }
            if (isNaN(this.day)) {
              this.day = 0;
            } else {
              if (this.allday.indexOf(Number(this.day)) == -1) {
                this.day = 0;
              }
            }
          }
          break;
        case "hour":
          // if (!this.isEnd) {
          //   let max_hour = Math.floor(
          //     (Number(this.max) - this.day * (24 * 60)) / 60
          //   );
          //   let max_minute =
          //     Number(this.max) - this.day * (24 * 60) - max_hour * 60;
          //   if (this.day == 0) {
          //     if (this.max) {
          //       if (Number(this.hour) > max_hour) {
          //         this.hour = this.max;
          //       }
          //     }
          //   } else {
          //   }
          // }
          if (this.hour) {
            if (isNaN(this.hour)) {
              this.hour = 0;
            } else {
              if (Number(this.hour) > 47) {
                this.hour = 47;
              }
              if (Number(this.hour) < 0) {
                this.hour = 0;
              }
            }
          }
          break;
        case "min":
          if (this.minute) {
            if (isNaN(this.minute)) {
              this.minute = 0;
            } else {
              if (Number(this.minute) > 59) {
                this.minute = 59;
              }
              if (Number(this.minute) < 0) {
                this.minute = 0;
              }
            }
          }
          break;
        default:
          break;
      }
    },
    setDay: function (day, input = false) {
      if (this.day == day && !input) {
        this.day = 0;
      } else {
        this.day = day;
      }
      if (this.day < 0) {
        this.time = "(" + this.day + ")" + this.hour + ":" + this.minute;
      } else
        this.time =
          this.day == 0
            ? this.hour + ":" + this.minute
            : "(+" + this.day + ")" + this.hour + ":" + this.minute;
      this.TimeMinute =
        this.timeMachine(Math.abs(this.day), this.hour, this.minute) *
        (this.day < 0 ? -1 : 1);
      // 滾動
      if (this.$refs["day"] && this.$refs["day"].scrollHeight) {
        let scroll = this.$refs["day"].scrollHeight;
        this.$refs["day"].scrollTo(
          0,
          (scroll / this.allday) * Number(day) - (scroll / this.allday) * 3
        );
      }
    },
    setHour: function (hour) {
      this.hour = hour;
      if (this.day < 0) {
        this.time = "(" + this.day + ")" + this.hour + ":" + this.minute;
      } else
        this.time =
          this.day == 0
            ? this.hour + ":" + this.minute
            : "(+" + this.day + ")" + this.hour + ":" + this.minute;
      this.TimeMinute =
        this.timeMachine(Math.abs(this.day), this.hour, this.minute) *
        (this.day < 0 ? -1 : 1);
      // 滾動
      if (this.$refs["hours"] && this.$refs["hours"].scrollHeight) {
        let scroll = this.$refs["hours"].scrollHeight;
        this.$refs["hours"].scrollTo(
          0,
          (scroll / 48) * Number(hour) - (scroll / 48) * 2
        );
      }
    },
    setMinute: function (minute) {
      this.minute = minute;
      if (this.day < 0) {
        this.time = "(" + this.day + ")" + this.hour + ":" + this.minute;
      } else
        this.time =
          this.day == 0
            ? this.hour + ":" + this.minute
            : "(+" + this.day + ")" + this.hour + ":" + this.minute;
      this.TimeMinute =
        this.timeMachine(Math.abs(this.day), this.hour, this.minute) *
        (this.day < 0 ? -1 : 1);
      // 滾動
      if (this.$refs["minutes"] && this.$refs["minutes"].scrollHeight) {
        let scroll = this.$refs["minutes"].scrollHeight;
        this.$refs["minutes"].scrollTo(
          0,
          (scroll / 60) * Number(minute) - (scroll / 60) * 2 - 1
        );
      }
    },
  },
};
</script>
<style >
.numberInput .v-text-field input {
  text-align: center !important;
  line-height: inherit !important;
}
</style>